import { render, staticRenderFns } from "./TituloPaginas.vue?vue&type=template&id=616187c8&"
import script from "./TituloPaginas.vue?vue&type=script&lang=js&"
export * from "./TituloPaginas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports